import {handleSend} from '../post'

const update602001 = (data) => {
  return handleSend(data, '60', '2001', data.operaType)
}

const list602002 = (data) => {
  data.pageNum = String(data.pageNum)
  data.pageSize = String(data.pageSize)
  return handleSend(data, '60', '2002')
}

const listMerch607001 = () => {
  return handleSend({}, '60', '7001')
}
export const HxApiBrand = {
  update602001,
  list602002,
  listMerch607001
}



// WEBPACK FOOTER //
// ./src/api/erp/info/brand.js